import { Command } from '@ckeditor/ckeditor5-core';
export default class InsertCopyableCommand extends Command {
    execute() {
        this.editor.model.change((writer) => {
            this.editor.model.insertContent(createCopyable(writer));
        });
    }
    refresh() {
        const model = this.editor.model;
        const selection = model.document.selection;
        const firstPosition = selection.getFirstPosition();
        const allowedIn = firstPosition && model.schema.findAllowedParent(firstPosition, 'copyable');
        this.isEnabled = allowedIn !== null;
    }
}
function createCopyable(writer) {
    const copyable = writer.createElement('copyable');
    const copyableLabel = writer.createElement('copyableLabel');
    const copyableText = writer.createElement('copyableText');
    writer.append(copyableLabel, copyable);
    writer.append(copyableText, copyable);
    writer.appendElement('paragraph', copyableText);
    return copyable;
}
